<template>
    <div class="idea-box mt20 mr20">
        <div class="left">
            <Material/>
        </div>
        <div class="right">
            <SelectMaterial/>
        </div>
    </div>
</template>

<script>
import Material from './material.vue'
import SelectMaterial from './selectMaterial.vue'
export default {
    components: { Material, SelectMaterial },
    data() { 
        return {
            
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.idea-box {
    position: relative;
    border: 1px solid #E4E7ED;
    display: flex;
    &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 38px;
        border: 2px solid #E4E7ED;
    }
   
    .left {
        flex: 1;
    }
    .right {
        width: 700px;
    }
}
</style>